import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase-client';

const getPlan = httpsCallable(functions, 'getCourseAssetPlan');
const cache = new Map();

function load(teamId, courseType, courseId) {
  const key = `${teamId}:${courseType}:${courseId}`;
  if (!cache.has(key)) cache.set(key, Promise.resolve(getPlan({ teamId, courseType, courseId })).then((result) => result?.data?.plan || {}));
  return cache.get(key);
}

export default function CourseBoatSummary({ teamId, courseType, courseId, sessionId }) {
  const [resources, setResources] = useState([]);
  const [state, setState] = useState('live');
  useEffect(() => {
    let active = true;
    if (!teamId || !courseId || !sessionId) return undefined;
    load(teamId, courseType, courseId).then((plan) => {
      if (!active) return;
      setResources((plan.sessions || []).find((session) => session.id === sessionId)?.reservations || []);
      setState(plan.state || 'live');
    }).catch(() => {});
    return () => { active = false; };
  }, [courseId, courseType, sessionId, teamId]);
  if (!resources.length) return null;
  return <div className="course-boat-summary" aria-label="Reserved club boats" style={{ marginTop: 8 }}>
    {resources.map((resource) => <div key={resource.id} className="text-muted">
      <strong>{resource.boatName}</strong> · Responsible: {resource.responsibleMemberName}{state === 'draft' ? ' · Provisional' : ''}
    </div>)}
  </div>;
}
